import React, { useState, useMemo, useEffect } from 'react';
import Pagination from '@components/Layout/Pagination';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AnalyticsAndReportBtn from './AnalyticsAndReportBtn';

const AnalyticsComponents = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    let UserRole = 'hospital';

    return (
        <div className='2xl:max-w-[1244px] xl:max-w-[940px] lg:max-w-[685px]'>
        {/* <div className=""> */}
            <AnalyticsAndReportBtn />
        </div>
    );
};

export default AnalyticsComponents;
